var map = {
	"./action_img.png": 3114,
	"./background.png": 12111,
	"./banner_shap.png": 74643,
	"./cloud-computing.png": 61490,
	"./cloud_01.png": 65886,
	"./cloud_02.png": 81026,
	"./cloud_03.png": 78328,
	"./cloud_04.png": 98422,
	"./cloud_05.png": 62948,
	"./cloud_06.png": 41133,
	"./crm_img1.jpg": 55059,
	"./crm_img2.jpg": 4742,
	"./crm_img3.jpg": 20375,
	"./erp_dashboard.jpg": 20851,
	"./erp_icon1.png": 73750,
	"./erp_icon2.png": 36956,
	"./erp_icon3.png": 90124,
	"./erp_icon4.png": 2680,
	"./erp_icon5.png": 17114,
	"./erp_icon6.png": 91761,
	"./growth.png": 53456,
	"./img/01.png": 43968,
	"./img/02.png": 42646,
	"./img/03.png": 37601,
	"./img/04.png": 14724,
	"./img/05.png": 5496,
	"./img/06.png": 9829,
	"./img/07.png": 66597,
	"./img/08.png": 6749,
	"./img/09.png": 92251,
	"./img/10.png": 86976,
	"./img/11.png": 44252,
	"./img/12.png": 97480,
	"./img/13.png": 89576,
	"./img/14.png": 845,
	"./img/15.png": 927,
	"./img/16.png": 40215,
	"./img/17.png": 8142,
	"./img/18.png": 79593,
	"./img/19.png": 73369,
	"./img/20.png": 37117,
	"./quote.png": 68830,
	"./rocket.png": 72931,
	"./settings1.png": 99784,
	"./shape.png": 73825,
	"./testimonial_img.jpg": 31845,
	"./testimonial_img2.jpg": 29936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75554;